import React from "react";
import ParagraphTag from "../reusebale/Paragraph";
import LabelTag from "../reusebale/label";
import ButtonTag from '../reusebale/button';

const FilterPopup = ({ onFilter, onBack }) => {

  return (
    <main className="w-full h-screen backdrop-blur-sm bg-black/80 fixed inset-0 z-50 flex items-center justify-center">
      <section className="w-[90%] sm:w-[65%] md:w-[50%] lg:w-[40%] xl:w-[18%] bg-texture myshades rounded-[31px] mx-auto">
        <div class="bg-white py-8 lg:py-5 rounded-xl justify-center items-center flex flex-col">
          <div>
            <ParagraphTag
              content="Filter"
              classes={`text-darkColor font-popinsSemiBold text-sm `}
            />
          </div>
          <div className="w-full px-2 mt-2">
            <LabelTag isStaric={false} name="Property" />
            <select  value='' className="w-full mt-2 bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor/40 placeholder:text-zinc-700/50 font-popinsRegular">
              <option value="Select1">Select 1</option>
              <option value="Select2">Select 2</option>
              <option value="Select3">Select 3</option>
            </select>

          </div>
          <div className="w-full px-2 mt-2">
            <LabelTag isStaric={false} name="Unit" />
            <select  value='' className="w-full mt-2 bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor/40 placeholder:text-zinc-700/50 font-popinsRegular">
              <option value="Select1">Select 1</option>
              <option value="Select2">Select 2</option>
              <option value="Select3">Select 3</option>
            </select>

          </div>
          <div className="w-full px-2 mt-2">
            <LabelTag isStaric={false} name="Statuses" />
            <select  value='' className="w-full mt-2 bg-bgColor px-3 py-2 text-sm rounded-lg text-darkColor/40 placeholder:text-zinc-700/50 font-popinsRegular">
              <option value="Select1">Select 1</option>
              <option value="Select2">Select 2</option>
              <option value="Select3">Select 3</option>
            </select>

          </div>
        <div className="w-full px-2">
            <ButtonTag onSubmit={onFilter} name='Filter' classes='text-sm bg-themeColor hover:bg-themeColor/90 mt-5 text-center  text-white' />
            <p className="text-darkColor pt-2 flex item-center justify-center cursor-pointer font-popinsMedium text-sm" onClick={onBack}>Close</p>
        </div>

        </div>
      </section>
    </main>
  );
};

export default FilterPopup;
